/**
 * «Подключения» (DF83): лёгкий ответ `/api/kraken-connections/active?light=true` приходит без счётчиков,
 * и строки рисовались нулями до полного ответа — «3 раза обновишь и покажет 3 раза разное». Счётчики строки
 * берутся из прошлого полного ответа; строка, которой в нём не было, — «ещё считаются» (`counts_pending`).
 */
export const CONNECTION_COUNT_FIELDS = ['modem_count', 'free_modems', 'reserve_blocked_modem_count'];

export function mergeLightConnections(previous, lightRows) {
  const known = new Map(
    (previous || []).filter((row) => !row.counts_pending).map((row) => [row.id, row]),
  );
  return (lightRows || []).map((row) => {
    const before = known.get(row.id);
    if (!before) return { ...row, counts_pending: true };
    const counts = {};
    CONNECTION_COUNT_FIELDS.forEach((field) => {
      counts[field] = before[field];
    });
    return { ...row, ...counts, counts_pending: false };
  });
}

/** Число в строке: «…», пока полный ответ не пришёл; у неактивного подключения — 0. */
export function connectionCount(record, value) {
  if (record?.counts_pending) return '…';
  return record?.is_active ? (Number(value) || 0) : 0;
}

/** Сумма модемов в шапке: «…», пока есть строки без счётчиков. */
export function totalModemsLabel(connections) {
  const rows = connections || [];
  if (rows.some((row) => row.counts_pending)) return '…';
  return rows.reduce((sum, row) => sum + (row.modem_count || 0), 0);
}
